import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";

import { Button } from "@/components/ui/button.tsx";
import { startLogin } from "@/lib/userActions.ts";
import { useAuthStatus } from "@/lib/userStore.ts";
import { useEffect } from "react";

type Search = { redirect?: string };

export const Route = createFileRoute("/login")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    redirect: s.redirect as string | undefined,
  }),
  component: LoginPage,
});

function LoginPage() {
  const status = useAuthStatus();
  const isAuthenticated = status === "authenticated";
  const isLoading = status === "loading";

  const router = useRouter();
  const { redirect } = useSearch({ from: "/login" }) as Search;

  const handleLogin = async () => {
    void startLogin(redirect);
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    if (redirect) {
      router
        .navigate({ to: redirect as any, replace: true })
        .catch(() => router.navigate({ to: "/dashboard", replace: true }));
    } else {
      router.navigate({ to: "/dashboard", replace: true }).catch(() => {});
    }
  }, [isAuthenticated, redirect, router]);

  if (isAuthenticated) {
    return (
      <main className="grid min-h-svh place-items-center p-6">
        <div className="w-80 space-y-4 text-center">
          <h1 className="text-xl font-semibold">Weiterleiten…</h1>
          <p className="text-xs text-muted-foreground">
            Bitte einen Moment gedulden.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="grid min-h-svh place-items-center p-6">
      <div className="w-80 space-y-4 text-center">
        <h1 className="text-xl font-semibold">Anmelden</h1>
        <Button onClick={handleLogin} className="w-full" disabled={isLoading}>
          {isLoading ? "Leite weiter…" : "Mit Microsoft anmelden"}
        </Button>
        <p className="text-xs text-muted-foreground">
          Du wirst zu Microsoft umgeleitet und anschließend zurückgeführt.
        </p>
      </div>
    </main>
  );
}
